<template>
	<DataTable v-bind="$attrs" v-on="$listeners" :fields="fields" :sort-aliases="sortAliases" @sorted.once="sorted"  @row-clicked="onRowClick">
		
		<!-- ID -->
		<template v-slot:[`cell(id)`]="{ value }">
			<span v-if="value">{{ value }}</span>
			<span v-else class="text-muted">&mdash;</span>
		</template>

		<!-- Appeal ID -->
		<template v-slot:[`cell(appeal_id)`]="data">
			<div class="d-flex justify-content-between align-items-center">
				<span>
				{{ data.item.appeal_id }}
				</span>
				<span
				v-if="data.item.request_id"
				:class="data.item.case_request?.deleted !== null ? 'circle-badger' : 'circle-badge'"
				>
				R
				</span>
			</div>
		</template>



		<!-- Status -->
		<template v-slot:[`cell(status_label)`]="data">
			<b-badge :title="data.item.status_label" pill :variant="data.item.progress_variant">
				{{ data.item.status_label }}
			</b-badge>
		</template>

		<!-- Patient Name -->
		<template v-slot:[`cell(patient.list_name)`]="data">
			<span class="font-weight-bold" v-if="data.item.case?.patient?.list_name">{{ data.item.case.patient.list_name }}</span>
			<span v-else class="text-muted">&mdash;</span>
		</template>

		<!-- Facility Name -->
		<template v-slot:[`cell(facility_name)`]="{ value }">
			<span v-if="value">{{ value }}</span>
			<span v-else class="text-muted">&mdash;</span>
		</template>

		<!-- Submitted By -->
		<template v-slot:[`cell(login_user)`]="{ value }">
			<span v-if="value">{{ value }}</span>
			<span v-else class="text-muted">&mdash;</span>
		</template>

		<!-- Level -->
		<template v-slot:[`cell(appeal_level_name)`]="{ value }">
			<span v-if="value">{{ value }}</span>
			<span v-else class="text-muted">&mdash;</span>
		</template>

		<!-- Method -->
		<template v-slot:[`cell(delivery_method)`]="data">
			<font-awesome-icon
				v-if="data.item.delivery_method_icon"
				:icon="data.item.delivery_method_icon"
				fixed-width
			/>
			<span v-if="data.item.delivery_method && data.item.delivery_method_label" class="mb-0">
				{{ data.item.delivery_method }}
			</span>
			<span v-else class="text-muted">&mdash;</span>
		</template>

		<!-- Recipient Type -->
		<template v-slot:[`cell(name_of_submit_to)`]="{ value }">
			<span v-if="value">{{ value }}</span>
			<span v-else class="text-muted">&mdash;</span>
		</template>

		<!-- Submit To -->
		<template v-slot:[`cell(submit_to)`]="{ value }">
			<span v-if="value">{{ value }}</span>
			<span v-else class="text-muted">&mdash;</span>
		</template>

		<!-- Sent Date -->
		<template v-slot:[`cell(created)`]="{ value }">
			<span v-if="value">{{ $filters.formatDate(value) }}</span>
			<span v-else class="text-muted">&mdash;</span>
		</template>

		<!-- Download -->
		<template v-slot:[`cell(download)`]="data">
			<b-dropdown 
				right 
				class="mb-0" 
			>
				<template #button-content>
					<font-awesome-icon icon="file-download" fixed-width />
				</template>
				<b-dropdown-item @click.stop="download(data.item)" title="Download Packet">
					Download
				</b-dropdown-item>
				<b-dropdown-item @click.stop="preview(data.item)">
					Preview
				</b-dropdown-item>
			</b-dropdown>
		</template>

	</DataTable>
</template>

<script>
import { mapGetters } from "vuex";
import DataTable from "@/clients/components/Layout/data-table.vue";
import store from "@/clients/store";
import axios from "axios";

export default {
	name: "outgoingTable",
	components: {
		DataTable,
	},
	props: {
		fields: {
			type: Array,
			default: () => {
                return [
                    {
						key: "id",
						label: "Submit ID",
						sortable: true,
                    },
                    
					{
						key: 'appeal_id',
						label: 'Appeal ID',
						sortable: true,
                    },
                    {
                        key: 'status_label',
                        label: 'Status',
                        sortable: true
                    },
                    {
                        key: "patient.list_name",
					    sortKey: "Patients.first_name",
                        label: 'Patient Name',
                        sortable: true
                    },

                    {
                        key: 'facility_name',
                        label: 'Facility',
                        sortable: true
                    },

                    {
                        key: 'login_user',
                        label: 'Submitted By',
                        sortable: true
                    },

                    {
						key: 'appeal_level_name',
                        label: 'Level',
                        sortable: true
                    },

                    {
                        key: 'delivery_method',
                        label: 'Method',
                        sortable: true
                    },
                    {
                        key: 'name_of_submit_to',
                        label: 'Recipient Type',
                        sortable: true
                    },

					{
						key: "submit_to",
						label: "Submit To",
						sortable: true,
                    },

                    {
                        key: 'created',
                        label: 'Sent Date',
                        sortable: true,
                    },

                    {
                        key: 'download',
                        label: 'Download',
                        sortable: false
                    },
					
                    
					
				];
			},
		},
		sort: {
			type: String,
			default: "created",
		},
		sortDescending: {
			type: Boolean,
			default: false,
		},
	},
	computed: mapGetters({
		sortAliases: "outgoingDocuments/sortAliases",
	}),
    methods: {
		onRowClick(item) {
         this.$emit('row-clicked', item); // Emit the event to the parent component
        },
        preview(result) {
		  
		  const pdfUrl = `/client/api/appeals/${result.id}/pdf?param=${result.filename}` ;
		  console.log("my file",result.filename)
		  if (pdfUrl) {
			window.open(pdfUrl, "_blank");
		  } else {
			console.error("PDF URL is not available");
		  }
		},
	  async download(result) {
		try {
		  await store.dispatch("outgoingDocuments/download", {
			id: result.id,
		  });
		} catch (error) {
		  console.error("Error downloading document:", error);
		}
	  },
		sorted(params) {
			this.$emit("update:sort", params.sort);
			this.$emit("update:sort-descending", params.sortDescending);
			this.$emit("sorted", params);
		},
		checkIfRebill(data) {
			if (data.item.appeal?.is_rebill) {
				return 'Re-bill'
				// // Prepare the payload for the POST request
				// const payload = {
				// 	case_id: data.item.case_id,  // Assuming you have a case_id in the data
				// 	appeal_id: data.item.appeal.id // Assuming appeal id is available in the data
				// };

				// // Make the axios.post request
				// axios.post('/client/api/getCurrentRebillLevelName', payload)
				// 	.then(response => {
				// 		console.log('Response from API:', response.data);
				// 	})
				// 	.catch(error => {
				// 		console.error('Error in API request:', error);
				// 	});

			} else {
				// If it's not a rebill appeal, return the appeal level name
				return data.item.appeal_level_name;
			}
		}	
	},
};
</script>

  <style scoped>
 
  .circle-badge {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  line-height: 16px;
  border-radius: 50%;
  background-color: #007bff; /* Change color as needed */
  color: white;
  text-align: center;
  font-size: 12px;
}
.circle-badger {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  line-height: 16px;
  border-radius: 50%;
  background-color: #ff0000; /* Change color as needed */
  color: white;
  text-align: center;
  font-size: 12px;
}

.mr-badger {
	display: inline-block;
	width: 20px;
	height: 18px;
	margin-left: 4px;
	line-height: 16px;
	border-radius: 50%;
	background-color: #ff0000; /* Change color as needed */
	color: white;
	text-align: center;
	font-size: 9px;
	font-weight: bold;
	vertical-align: middle;
}
.mr-badge {
	display: inline-block;
	width: 20px;
	height: 18px;
	margin-left: 4px;
	line-height: 16px;
	border-radius: 50%;
	background-color: #007bff; /* Change color as needed */
	color: white;
	text-align: center;
	font-size: 9px;
	font-weight: bold;
	vertical-align: middle;
}



  </style>